import React from 'react';
import { useTranslation } from 'react-i18next';
import { useApolloClient } from '@apollo/client';
import Select, {
  IProps as ISelectProps,
  IValue,
  IValues,
} from '../../../../../../components/_select/_module/Select';
import {
  dropshippingRequestCompanyQuery,
  IDropshippingRequestCompanyQueryData,
  IDropshippingRequestCompanyVars,
  IDropshippingRequestCompanyVarsPartial,
} from '../../../../../../../graphql/query/dropshippingRequestCompany/useDropshippingRequestCompanyQuery';
import useLanguage from '../../../../../../components/_hook/useLanguage';

interface IProps {
  filter?: IDropshippingRequestCompanyVars['filter'];
}

export default function SelectDropshippingRequestCompanyRelatedCompany<
  TValue extends IValue | IValues
>(props: IProps & ISelectProps<TValue>) {
  const { t } = useTranslation();
  const { getText } = useLanguage();
  const client = useApolloClient();
  const {
    creatable,
    disabled,
    label,
    onChange,
    placeholder,
    value,
    menuPosition,
    required,
    margin,
    error,
    fullWidth,
    helperText,
    isMulti,
    filter,
  } = props;

  return (
    <Select<TValue>
      creatable={creatable}
      isMulti={isMulti}
      async
      isClearable
      loadOptions={async (input) => {
        const { data } = await client.query<
          IDropshippingRequestCompanyQueryData,
          IDropshippingRequestCompanyVarsPartial
        >({
          query: dropshippingRequestCompanyQuery(`
                _id
                toCompanyData {
                   _id
                   name {
                    text
                    la
                   }
                }
              `),
          variables: {
            filter,
            search: {
              toCompanyName: input,
            },
            limit: 8,
          },
        });

        if (data && data.dropshippingRequestCompanies) {
          return data.dropshippingRequestCompanies.items.map(
            (dropshippingRequestCompany) => ({
              label: dropshippingRequestCompany.toCompanyData
                ? getText(dropshippingRequestCompany.toCompanyData.name)
                : '',
              value: dropshippingRequestCompany._id,
            })
          );
        }

        return [];
      }}
      menuPosition={menuPosition}
      label={label}
      required={required}
      margin={margin}
      error={error}
      disabled={disabled}
      fullWidth={fullWidth}
      helperText={helperText}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
}
